/**
 * number 인풋에 포커스된 채 휠을 돌리면 값이 바뀌는 브라우저 기본 동작을 막는다.
 * (포커스되지 않은 인풋 위에서의 페이지 스크롤은 그대로 둔다.)
 */
export function blockNumberInputWheel(event: WheelEvent): void {
  const el = event.target
  if (!(el instanceof HTMLInputElement) || el.type !== 'number') return
  if (document.activeElement !== el) return
  event.preventDefault()
}
